export const CREATE_SURVEY_SUCCESS = "CREATE_SURVEY_SUCCESS";
export const UPDATE_SURVEY_SUCCESS = "UPDATE_SURVEY_SUCCESS";
export const DELETE_SURVEY_SUCCESS = "DELETE_SURVEY_SUCCESS";
export const FETCH_SURVEYS_SUCCESS = "FETCH_SURVEYS_SUCCESS";
export const UPDATE_SURVEY_STATUS_SUCCESS = "UPDATE_SURVEY_STATUS_SUCCESS";
export const DUPLICATE_SURVEY_SUCCESS = "DUPLICATE_SURVEY_SUCCESS";

